/**
 * Общие куски HTML для печати чековых документов (58 мм).
 *
 * Используется и уведомлением о продаже, и копией фискального чека:
 * раньше обе функции держали свои копии экранирования и строк позиций,
 * из-за чего правка шаблона требовала двух одинаковых изменений.
 */

export interface OrganizationHeader {
  company: string
  inn: string
  address: string
}

export const UNKNOWN_COMPANY = 'Организация'

/** Экранирование для вставки в печатный HTML. */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/"/g, '"')
}

/** Реквизиты заполнены: без них уведомление печатать нельзя. */
export function isOrganizationReady(header: OrganizationHeader): boolean {
  return (
    header.company.trim() !== '' &&
    header.company.trim() !== UNKNOWN_COMPANY &&
    header.inn.trim() !== '' &&
    header.inn.trim() !== '—' &&
    header.address.trim() !== '' &&
    header.address.trim() !== '—'
  )
}

export interface PrintableItem {
  name: string
  qty: number
  price: number
}

/** Строки позиций: «Название 2 x 50.00 … 100.00». */
export function receiptItemsHtml(items: PrintableItem[]): string {
  return items
    .map(
      (item) =>
        `<div class="line"><span>${escapeHtml(item.name)} ${escapeHtml(item.qty)} x ${item.price.toFixed(2)}</span><span>${(item.price * item.qty).toFixed(2)}</span></div>`
    )
    .join('')
}

/** Шапка с ИНН и адресом — общая для фискальной копии и уведомления. */
export function organizationHtml(header: OrganizationHeader): string {
  return [
    `<div class="line"><span>ИНН</span><span>${escapeHtml(header.inn)}</span></div>`,
    `<div class="line"><span>Адрес</span><span>${escapeHtml(header.address)}</span></div>`
  ].join('')
}

/** Способ оплаты по-русски (для печатных документов). */
export function paymentMethodLabel(method?: string): string {
  if (method === 'cash') return 'наличные'
  if (method === 'card') return 'карта'
  if (method === 'sbp') return 'СБП'
  return method ? escapeHtml(method) : '—'
}
